import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetMyAccountServicesDetail } from '@services/useGetMyAccountServiceDetail';
import { ManageServicesEdit } from '@components/templates/myAccount/manageServicesEdit';

export function ManageServicesEditPage() {
    const { myAccountServiceDetail } = useData();
    const { request: requestMyAccountServiceDetail } = useGetMyAccountServicesDetail();
    const { uuid } = useParams();
    const { t, i18n } = useTranslation();

    // fetch service detail info
    useEffect(() => {
        requestMyAccountServiceDetail({ uuid: uuid || '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid, i18n.language]);

    const translations = {
        title: t('manage-services-edit-component.metatags.title', { name: myAccountServiceDetail?.data?.name }),
        description: t('manage-services-edit-component.metatags.description', {
            name: myAccountServiceDetail?.data?.name,
        }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myServicesEdit.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <ManageServicesEdit />;
}
